























import { Vue, Component } from "vue-property-decorator";
import store from "@/store";
//  components
import FleetOverviewTable from "@/components/dataQuality/FleetOverviewTable/index.vue";
//  types
import { DataQualityHeader } from "@/types/dataQuality/dataQualityTable";
import { headers } from "./VDataTableHeaders/FleetOverview";
//  modules
import { getModule } from "vuex-module-decorators";
import DataQualityModule from "@/store/clients/DataQuality.module";
import VesselsModule from "@/store/clients/Vessels.module";

const Vessels = getModule(VesselsModule, store);
const DataQuality = getModule(DataQualityModule, store);

@Component({
  components: {
    FleetOverviewTable,
  },
})
export default class DQFleetOverview extends Vue {
  searchQuery = "";
  links: (string | null)[] = [null, "/DataQuality/DataAvailability", "/DataQuality/DataOutliers", null, "/DataQuality/DataAlignment"];

  headers: DataQualityHeader[] = headers;

  //  @Getters
  get rows(): any {
    var rows = DataQuality.fleetOverview.map((item, index) => {
      const vessel = Vessels.extendedVessels.find(vessel => vessel.id === item.vesselId);
      return {
        key: index,
        vesselName: {
          value: vessel ? vessel.name : "Unknown Vessel",
          link: vessel?.name ? `/Vessel/${item.vesselId}/${encodeURIComponent(vessel.name)}` : null,
        },
        dataAvailability: {
          value: item.dataAvailability,
          link: "/DataQuality/DataAvailability",
        },
        dataOutliers: {
          value: item.dataOutliers,
          link: "/DataQuality/DataOutliers",
        },
        speedLog: {
          value: item.speedLog,
          link: "/DataQuality/SpeedLog",
        },
        noonReportAlignment: {
          value: item.noonReportAlignment,
          link: "/DataQuality/DataAlignment",
        },
      };
    });
    return Boolean(this.searchQuery !== null && this.searchQuery.trim()) ? rows.filter(item => item.vesselName.value.toLowerCase().includes(this.searchQuery.toLowerCase())) : rows;
  }

  get tableLoading(): boolean {
    return DataQuality.loadingState;
  }

  //  @Methods
  onIndicatorClicked(data: any): void {
    this.$router.push({
      path: data.link,
      query: { find: this.rows[data.rowIndex].vesselName.value },
    });
  }

  //  @Hooks
  async created(): Promise<void> {
    await Promise.all([Vessels.refreshExtendedVessels(), DataQuality.refreshFleetOverview()]);
  }
}
